import { registerRoute } from '../../app/registry';
import NotificationsList from './NotificationsList';

registerRoute({
  path: '/notifications',
  element: <NotificationsList />,
  nav: { label: 'Notifications', order: 90, icon: '🔔' },
  // No roles => any authenticated user; each user sees only their own rows.
});
